import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { DraftStore } from "@src/views/create-project/drafts/domain/drafts-model";
import moment from "moment";

export const fetchDraftList = createAsyncThunk<any[], string>(
  "draft/fetchDraft",
  async (userId: string) => {
    const response = await api.get<ApplicationResponse<any[]>>(
      `${AppConstants.api}/draft/list?userId=${userId}`
    );
    const formattedData = response.data.data?.map((entry) => ({
      ...entry,
      date: moment
        .utc(entry.date, "YYYY-MM-DD HH:mm:ss.SSS")
        .local()
        .format("DD MMMM YYYY hh:mm A"),
    }));
    return formattedData || [];
  }
);
export const deleteDraft = createAsyncThunk<
  void,
  { draftId: any; type: "npms" | "eci" | "custom" }
>("draft/deleteDraft", async ({ draftId, type }) => {
  try {
    const url = `${AppConstants.api}/draft/delete?draftId=${draftId}&type=${type}`;
    const response = await api.delete<ApplicationResponse<any[]>>(url);
  } catch (error) {
    console.error("Delete Draft Error:", error);
  }
});
const DraftSlice = createSlice({
  name: "draft",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as DraftStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDraftList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchDraftList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchDraftList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default DraftSlice.reducer;
